import { AuthUser } from 'aws-amplify/auth'; // Correct import
import { signIn, signOut, getCurrentUser } from 'aws-amplify/auth';
import { resetPassword, type ResetPasswordOutput } from 'aws-amplify/auth';

// Sign in
export const authSignIn = async (username: string, password: string): Promise<Boolean> => {
  try {
    const result = await signIn({ username: username, password:password });
    return result.isSignedIn;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message || 'Error signing in');
    } else {
      throw new Error('Unknown error signing in');
    }
  }
};

// Sign out
export const authSignOut = async (): Promise<void> => {
  try {
    await signOut();
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(error.message || 'Error signing out');
    } else {
      throw new Error('Unknown error signing out');
    }
  }
};

// Get current authenticated user
export const authGetUser = async (): Promise<AuthUser | null> => { // Return type is AuthUser | null
    try {
      // Attempt to get the current user using AWS Amplify's method
      const currentUser = await getCurrentUser(); // This method gets the authenticated user
      return currentUser; // If user is signed in, return the user object
    } catch (error) {
      // If there's an error (e.g., user is not signed in), log the error and return null
      console.log("Not signed in");
      return null; // Return null if no user is authenticated
    }
  };


  export const handleResetPassword = async (username: string): Promise<string> => {
    try {
      const output = await resetPassword({ username });
      return handleResetPasswordNextSteps(output);
    } catch (error) {
      console.log(error);
    }
    return 'ERROR';
  };
  
  export const handleResetPasswordNextSteps = (output: ResetPasswordOutput): string =>{
    const { nextStep } = output;
    switch (nextStep.resetPasswordStep) {
      case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        console.log(
          `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
        );
        return 'SENT';
        // Collect the confirmation code from the user and pass to confirmResetPassword.
        break;
      case 'DONE':
        console.log('Successfully reset password.');
        return 'DONE';
        break;
    }
  };
